export default "__VITE_ASSET__0b84745f__"